/**
 * Admin module routes
 */

import { Routes, Route } from 'react-router-dom'
import AdminDashboardPage from './pages/AdminDashboardPage'
import UsersPage from './pages/UsersPage'
import DivisionsPage from './pages/DivisionsPage'

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<AdminDashboardPage />} />
      <Route path="/users" element={<UsersPage />} />
      <Route path="/divisions" element={<DivisionsPage />} />
    </Routes>
  )
}

export default AdminRoutes
